//
// ===== File globals.ts
//
"use strict";

// export var BASE_URL = 'http://localhost:3002';
// export var URL_MQTT = 'http://localhost:5002';
// export var URL_MQTT_ALARMAS = 'http://localhost:5001';

//Producción
// export var BASE_URL = 'http://52.67.144.82:3002';
// export var URL_MQTT = 'http://52.67.144.82:5002';
// export var URL_MQTT_ALARMAS = 'http://52.67.144.82:5001';

//Testing
// export var BASE_URL = 'http://18.228.93.199:3002';
// export var URL_MQTT = 'http://18.228.93.199:5002';
// export var URL_MQTT_ALARMAS = 'http://18.228.93.199:5001';

// export var BASE_URL = 'http://gornatilabs.com:3002';
// export var URL_MQTT = 'http://gornatilabs.com:5000';
// export var URL_MQTT_ALARMAS = 'http://gornatilabs.com:5001';

//Comarsa
// export var BASE_URL = 'http://192.168.0.25:3002';
// export var URL_MQTT = 'http://192.168.0.25:5000';
// export var URL_MQTT_ALARMAS = 'http://192.168.0.25:5001';

// TODO: ver estas variables junto al entorno de desarrollo
if (process.env.ENV === "development") {
    var BASE_URL = "http://localhost:3002";
    var URL_MQTT = "http://localhost:5002";
    var URL_MQTT_ALARMAS = "http://localhost:5001";
}
if (process.env.ENV === "production") {
    var BASE_URL = "https://app.bemakoha.com/api";
    var URL_MQTT = "https://app.bemakoha.com";
    var PATH_MQTT = "/mqtt/socket.io";
    var URL_MQTT_ALARMAS = "https://app.bemakoha.com";
    var PATH_MQTT_ALARMAS = "/alarms/socket.io";
}
if (process.env.ENV === "staging") {
    var BASE_URL = "https://appdev.bemakoha.com/api";
    var URL_MQTT = "https://appdev.bemakoha.com";
    var PATH_MQTT = "/mqtt/socket.io";
    var URL_MQTT_ALARMAS = "https://appdev.bemakoha.com";
    var PATH_MQTT_ALARMAS = "/alarms/socket.io";
}

export default {
    BASE_URL: BASE_URL,
    URL_MQTT: URL_MQTT,
    PATH_MQTT: PATH_MQTT,
    URL_MQTT_ALARMAS: URL_MQTT_ALARMAS,
    PATH_MQTT_ALARMAS: PATH_MQTT_ALARMAS,
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/config.ts